// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eGdZ","type":"styles_type__1mkLZ","choices":"styles_choices__1olR0"};